var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResidentLogoNavbar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5149 6.33443L26.6442 27.0842H4.35726L15.5149 6.33443ZM15.5179 2L1 29H30L15.5179 2Z",
    fill: "url(#paint0_linear_17554_20028)",
    stroke: "url(#paint1_linear_17554_20028)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17554_20028",
    x1: 3.04802,
    y1: 30.7532,
    x2: 23.1685,
    y2: 12.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#652092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F54DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FF83B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17554_20028",
    x1: 3.04802,
    y1: 30.7532,
    x2: 23.1685,
    y2: 12.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#652092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F54DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FF83B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD83"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentLogoNavbar);
export default __webpack_public_path__ + "static/media/resident-logo-navbar.3318234b9bad247ab4b70fe46cef5e7e.svg";
export { ForwardRef as ReactComponent };